/**
 * Service module for the Seller entity
 * @module SellerService
 *
 * This module contains all requests regarding the seller of the lead.
 * The purpose is to place requests that are only related to the seller.
 */
import { SellersAxios } from '@/config/axios';
/**
 * Returns the rooftop/company information in an object
 * @param {string} id Represents the companies_id of the seller
 * @param {object} config Represents an Axios request config object
 * @returns {Promise} Axios promise object represents the rooftop information
 */
export function getRooftopById(id, config = {}) {
  return SellersAxios.get(`/rooftop/${id}`, config);
}

export default {
  getRooftopById,
};
